import { BritishColumbiaObstetricalFileAboRhFactor } from "./Section13/BritishColumbiaObstetricalFileAboRhFactor";
import { BritishColumbiaObstetricalFileTests } from "./Section13/BritishColumbiaObstetricalFileTests";
import { BritishColumbiaObstetricalFilePrenatalGeneticInvestigation } from "./BritishColumbiaObstetricalFilePrenatalGeneticInvestigation";

class BritishColumbiaObstetricalFileInvestigations {
    public AboRhFactor: BritishColumbiaObstetricalFileAboRhFactor;
    public TestResults: BritishColumbiaObstetricalFileTests;
    public PrenatalGenetic: BritishColumbiaObstetricalFilePrenatalGeneticInvestigation;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileInvestigations>) {
        Object.assign(this, fields);

        this.AboRhFactor = new BritishColumbiaObstetricalFileAboRhFactor(fields?.AboRhFactor);
        this.TestResults = new BritishColumbiaObstetricalFileTests(fields?.TestResults);
        this.PrenatalGenetic = new BritishColumbiaObstetricalFilePrenatalGeneticInvestigation(fields?.PrenatalGenetic);
    }
}

export { BritishColumbiaObstetricalFileInvestigations };
